import { useEffect } from "react";
import { Skeleton } from "@mui/material";
import Button from "components/atoms/Button";
import PaymentService from "services/payment.service";
import { MODAL, modalActions } from "redux/slices/modal";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import CreditCardOffOutlined from "@mui/icons-material/CreditCard";

import PaypalImg from "assets/paypal.png";

export default function PaymentMethod() {
	const dispatch = useAppDispatch();
	const stripe = useAppSelector((state) => state.payment.stripe);
	const paypal = useAppSelector((state) => state.payment.paypal);
	const loading = useAppSelector((state) => state.payment.loading);
	const selected = useAppSelector((state) => state.payment.selected);

	useEffect(() => {
		PaymentService.getAllMethods();
	}, []);

	return (
		<>
			{loading ? (
				<Skeleton
					variant="rectangular"
					sx={{
						position: "absolute",
						right: "6px",
						top: "24px",
						height: "2em",
						width: "70px",
					}}
				/>
			) : stripe.length + paypal.length > 0 ? (
				<Button
					variant="text"
					sx={{
						position: "absolute",
						top: "22px",
						right: "10px",
						textTransform: "capitalize",
					}}
					onClick={() =>
						dispatch(
							modalActions.openModal({
								type: MODAL.PAYMENT_CARDS,
								data: "",
								width: "500px",
							})
						)
					}
				>
					Edit
				</Button>
			) : (
				<Button
					variant="text"
					sx={{
						position: "absolute",
						top: "22px",
						right: "10px",
						textTransform: "capitalize",
					}}
					onClick={() =>
						dispatch(
							modalActions.openModal({
								type: MODAL.ADD_STRIPE_PAYMENT,
								data: "trip",
								width: "500px",
							})
						)
					}
				>
					Add
				</Button>
			)}
			{loading ? (
				<Skeleton variant="rectangular" height={40} />
			) : (
				selected.card && (
					<div className="text-with-icon">
						<p style={{ display: "flex" }}>
							{selected.payment_type === "card" ? <CreditCardOffOutlined /> :
								<img
									style={{ width: "30px", height: "30px", marginRight: 0 }}
									loading="lazy"
									src={PaypalImg}
									alt={"Paypal"}
								/>
							}
						</p>
						<p>
							{selected.payment_type === "card"
								? `**** **** **** ${selected.card.last4}`
								: selected.card.email}
						</p>
					</div>
				)
			)}
		</>
	);
}
